/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import serverClientUtil from '../../../../utils/serverClientUtil';
import {
  handleUserLogout,
  _handleUserLogin,
} from '../../../../pages/Accounts/createAccount/actions';
import * as BrowseAndNevigateSearchAction from '../../../../pages//BrowseAndNavigate/BrowseAndNevigateSearch/actions';
import commonUtil from '../../../../utils/commonUtil';

const styles = {
  display: 'block',
  padding: '10px 0',
  textDecoration: 'none',
  fontSize: '1.1em',
  fontFamily: 'robotoregular',
  color: '#000',
  whiteSpace: 'pre-wrap',
};
@connect(
  store => ({
    Home: store.labels.data.home,
    megaMenuData: store.megaMenuData.data,
    cartCountData: store.cartCountData.data,
    SearchedPoductData: store.SearchedPoductData.data,
  }),
  { ...BrowseAndNevigateSearchAction },
)
class CommonTypeHeadLeft extends Component {
  constructor() {
    super();
    this.state = {
      onHoverClass: 'no-hover',
      inputSearch: '',
      staticLabelKeys: {}
    };
    this.debounceSearchTerm = this.debounceSearchTerm.bind(this);
    this.searchTermOver = this.searchTermOver.bind(this);
    this.searchSuggestionParams = this.searchSuggestionParams.bind(this);
    this.redirectToUrl = this.redirectToUrl.bind(this);
    this.isSuggestionSearch = this.isSuggestionSearch.bind(this);
  }
  // Start Changes for GR Serach Facade
  redirectToUrl = (e, href, asPath = href, searchFromSuggestion) => {
    if (!_.isEmpty(e)) {
        e.preventDefault();
    }
    if (!_.isEmpty(href)) {
        // Router.push(href, asPath);
        //window.location.href = href;
        window.location.href = serverClientUtil.getLPFullURL() + asPath
    }
}
  searchSuggestionParams = (
    positionArrayResult,
    titleLink,
    searchTerm,
    firstSuggesion,
  ) => {
    try {
      const positionSuggestion =
        positionArrayResult && firstSuggesion
          ? positionArrayResult
          : positionArrayResult + 2;
      const textSuggestion = firstSuggesion
        ? titleLink
        : `${titleLink.label} en ${
            titleLink.subItem.label
              ? titleLink.subItem.label
              : titleLink.subItem
          }`;
      const values = { positionSuggestion, textSuggestion, searchTerm };
      sessionStorage.setItem('searchSuggestion', JSON.stringify(values));
      // let { setSuggestionSearch } =  this.context;
      // setSuggestionSearch({...values, category: titleLink && titleLink.label || "","href":href});
    } catch (error) {
      console.log('Error searchSuggestionParams ', error);
    }
  };

  searchTermOver = (keyword, type, searchTerm) => {
    let payLoad = '';
    const newPayload = {};
    //this.hideTodosMouseOver = true;
    const { SearchedDetailOfPoduct } = this.props;
    if (type == 'products') {
      payLoad = `?query=${encodingParam(keyword)}&type=${type}`;
      (newPayload.query = encodingParam(keyword) || ''),
        (newPayload.type = type || '');
    } else {
      payLoad = `?refinementValue=${encodingParam(
        keyword,
      )}&query=${encodingParam(searchTerm)}&requestType=${type}&type=products`;
      (newPayload.query = encodingParam(searchTerm) || ''),
        (newPayload.type = 'products');
      (newPayload.refinementValue = encodingParam(keyword) || ''),
        (newPayload.requestType = type || '');
    }
    SearchedDetailOfPoduct(payLoad, newPayload).then((res) => {
      if (res.status.status === 'success') {
        const _dataLayer = this.getTaggingData(payLoad);
        this.tagging.applyGTM('SearchProduct', _dataLayer);
      } else {
        const _dataLayer = this.getTaggingDataFailure(payLoad);
        this.tagging.applyGTM('SearchProduct', _dataLayer);
      }
    });
  };

  // delay by 1 second
  debounceSearchTerm = (func, timeout = 1000) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  };

  isSuggestionSearch = () => {
    sessionStorage.setItem('isSuggestionSearch', 'true');
}

  // End Changes for GR Serach Facade

  render() {
    const { SearchedPoductData, Home } = this.props;
    const channel = commonUtil.getChannel();
    const searchFromSuggestion = true;
    // console.log("prosps===",this.props)
    const email =
      this.props.user && this.props.user.data && this.props.user.data.result
        ? this.props.user.data.result.emailId
        : '';
    if (this._loginLi) {
      this.checkSession();
    }
    this.cartCount = 0;
    if (
      this.props.cartCountData &&
      this.props.cartCountData.cartDetails &&
      this.props.cartCountData.cartDetails.length > 0
    ) {
      this.props.cartCountData.cartDetails.map(
        data => (this.cartCount += parseInt(data.quantity, 10)),
      );
    }
    // Start Changes for GR Serach Facade
    const searchTerm = this.props.inputSearch;
    const anchorBrandTags =
      SearchedPoductData &&
      SearchedPoductData.suggestion &&
      SearchedPoductData.suggestion.brands &&
      SearchedPoductData.suggestion.brands.length > 0 &&
      Array.isArray(SearchedPoductData.suggestion.brands)
        ? SearchedPoductData.suggestion.brands.map((item, key) => {
          const asInfo = `?s=${item.split(' ').join('+')}`;
          {this.isSuggestionSearch()}
          const href = `/tienda/twoColumnCategoryPage?searchValue=${escape(
              item,
            )}&type=brand`;
          const titleLink = {"suggestion":searchTerm+" en "+item};
          const text = getLabel(searchTerm, item, this.props.color);
          const searchTermsArrlen = SearchedPoductData.suggestion.searchTerms && parseInt(SearchedPoductData.suggestion.searchTerms.length) || 0;
          const positionkey = searchTermsArrlen + parseInt(key) + 1;
          const new_text = <div dangerouslySetInnerHTML={{ __html: text }} />;

          return (
             <a onMouseOver={this.debounceSearchTerm(() => this.searchTermOver(item, 'brand',searchTerm))} onClick={(e) =>{this.searchSuggestionParams(positionkey, titleLink, searchTerm,item); this.redirectToUrl(e, href, asInfo, searchFromSuggestion,'brand',positionkey)}} href="#" className="a-header__typeaheadLink typeahead-link" key={`${key}_${item.value}`} style={styles}>{new_text}</a>
          );
        })
        : null;

    const anchorSearchTags =
      SearchedPoductData &&
      SearchedPoductData.suggestion &&
      SearchedPoductData.suggestion.searchTerms &&
      SearchedPoductData.suggestion.searchTerms.length > 0 &&
      Array.isArray(SearchedPoductData.suggestion.searchTerms)
        ? SearchedPoductData.suggestion.searchTerms.map((item, key) => {
          const value = item.value;
          const type = 'products';
          {this.isSuggestionSearch()}
          const asInfo = `?s=${value.split(' ').join('+')}`;
          const href = `/tienda/twoColumnCategoryPage?s=${value}&path=PLP`;
          const titleLink = {"suggestion":searchTerm +" en "+ value}
          const text = getLabeledSearchTerms(
              searchTerm,
              value,
              this.props.color,
            );
          const positionkey = key + 1;
          const new_text = <div dangerouslySetInnerHTML={{ __html: text }} />;

          return (
            <a onMouseOver={this.debounceSearchTerm(() => this.searchTermOver(value, type))} onClick={(e) => {this.searchSuggestionParams(positionkey, titleLink, searchTerm,value,"popularSearch"); this.redirectToUrl(e, href, asInfo, searchFromSuggestion,'products',positionkey)}} href="#" className="a-header__typeaheadLink typeahead-link" key={`${key}`} style={styles}>{new_text}</a>
          );
        })
        : null;

    const anchorCategoryTags =
      SearchedPoductData &&
      SearchedPoductData.suggestion &&
      SearchedPoductData.suggestion.categories &&
      SearchedPoductData.suggestion.categories.length > 0 &&
      Array.isArray(SearchedPoductData.suggestion.categories)
        ? SearchedPoductData.suggestion.categories.map((item, key) => {
          const catName = item.name;
          const catId = item.id;
          const path = item.showPath;
          const brandsArrlen = SearchedPoductData.suggestion.brands && SearchedPoductData.suggestion.brands.length || 0;
          const searchTermsArrlen = SearchedPoductData.suggestion.searchTerms && parseInt(SearchedPoductData.suggestion.searchTerms.length);
          const positionkey = searchTermsArrlen + parseInt(brandsArrlen) + parseInt(key) + 1;
          const asInfo = `/${catName.split(' ').join('-')}/${catId}`;
          const href = `/tienda/twoColumnCategoryPage?categoryId=${catId}&path=${path}`;

          const text = getLabel(searchTerm, catName, this.props.color);
          const new_text = <div dangerouslySetInnerHTML={{ __html: text }} />;
          const titleLink = { catName };
          const positionArrayResult = key;

          return (
            <a onMouseOver={this.debounceSearchTerm(() => this.searchTermOver(catId, 'category',searchTerm))} onClick={(e) => {this.searchSuggestionParams(positionkey, titleLink, searchTerm,catName);this.redirectToUrl(e, href, asInfo, searchFromSuggestion,'category',positionkey)}} href="#" className="a-header__typeaheadLink typeahead-link" key={`${key}`} style={styles}>{new_text}</a>
          );
        })
        : null;

    // End Changes for GR Serach Facade
    const stylesForWap = {
      backgroundColor: '#fff',
      position: 'absolute',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .15)',
      borderRadius: '4px',
      margin: '3px 0 0 0',
      width: '90%',
      zIndex: '10',
      paddingLeft: '10px',
    };
    return (
      <div className="m-typeAhead__left" style={channel === 'wap' ? stylesForWap : {}}>
        {/* Start Changes for GR Serach Facade  */}
        <div className="col-lg-12 col-12 results">
          {/* <div className="row d-flex d-lg-none">
                <SearchBarMobileModal clearSearchbar={clearSearchbar} onKeypress={onKeypress} handleTypeheadShow={handleTypeheadShow} handleTypeheadHide={handleTypeheadHide} onChangeSearchbar={onChangeSearchbar} searchTerm={searchTerm} />
                  {
                      (searchbarClicked && searchTerm.length === 0) ?
                      <div className="row d-flex" dangerouslySetInnerHTML={{__html : trendingTypeAhead}}></div>
                      : null
                  }
            </div> */}

          {
            // searchTerm.length >= MIN_TYPEHEAD_LENGTH && showCardImg ?
            searchTerm.length ? (
              <div className="row">
                <div className="col-12">
                  <div className="m-header__searchLinkResult">
                    {/* {
                          (SearchedPoductData.suggestion.products.length === 0) ?
                                <AnchorSpan typeaheadclass="a-header__typeaheadLink" onClick={(e) => {this.searchSuggestionParams(1, `${searchTerm} en Todos los Departamentos`, searchTerm, true); redirectToUrl(e, `/tienda/twoColumnCategoryPage?s=${searchTerm}`, `/tienda?s=${searchTerm}`)}} href="#" anchorText={`${searchTerm}`} spanText="" />
                            : null
                        } */}

                    {anchorSearchTags}

                    {SearchedPoductData.suggestion.brands &&
                    SearchedPoductData.suggestion.brands.length > 0 &&
                    SearchedPoductData.suggestion.brands &&
                    Array.isArray(SearchedPoductData.suggestion.brands) ? (
                      <hr style={{ borderTop: '1px solid rgba(0,0,0,.1)' }} />
                    ) : null}
                    {SearchedPoductData.suggestion.brands &&
                    SearchedPoductData.suggestion.brands.length > 0 &&
                    SearchedPoductData.suggestion.brands &&
                    Array.isArray(SearchedPoductData.suggestion.brands) ? (
                      <h5
                        style={{
                          color: '#000',
                          fontSize: '1.25em',
                          fontWeight: 'bold',
                        }}
                        headLineText={
                          this.state.staticLabelKeys[
                            'homepage.typeahead.brand'
                          ] || 'Buscar en Marcas'
                        }
                      >
                        {'Buscar en Marcas'}
                      </h5>
                    ) : null}

                    {anchorBrandTags}

                    {SearchedPoductData.suggestion.categories &&
                    SearchedPoductData.suggestion.categories.length > 0 &&
                    SearchedPoductData.suggestion.categories &&
                    Array.isArray(SearchedPoductData.suggestion.categories) ? (
                      <hr style={{ borderTop: '1px solid rgba(0,0,0,.1)' }} />
                    ) : null}
                    {SearchedPoductData.suggestion.categories &&
                    SearchedPoductData.suggestion.categories.length > 0 &&
                    SearchedPoductData.suggestion.categories &&
                    Array.isArray(SearchedPoductData.suggestion.categories) ? (
                      <h5
                        style={{
                          color: '#000',
                          fontSize: '1.25em',
                          fontWeight: 'bold',
                        }}
                        headLineText={
                          this.state.staticLabelKeys[
                            'homepage.typeahead.category'
                          ] || 'homepage.typeahead.category'
                        }
                      >
                        {'Buscar en Categorías'}
                      </h5>
                    ) : null}
                    {anchorCategoryTags}
                  </div>
                </div>
              </div>
            ) : null
          }
        </div>
        {/* End Changes for GR Serach Facade  */}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  label: state.labels.data,
  user: state.user,
  eventDetails: state.eventDetail,
});
const matchDispatchToProps = dispatch =>
  bindActionCreators({ handleUserLogout, _handleUserLogin }, dispatch);
export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(CommonTypeHeadLeft);

// Start Changes for GR Serach Facade
const getLabeledSearchTerms = (searchTerm, title, color) => {
  const colorCode = color || '#e10098';
  let str = title;
  title = title;
  searchTerm = searchTerm.replace(' ', '');
  if (title.indexOf(searchTerm) !== -1) {
    const startIndex = title.indexOf(searchTerm);
    const len = searchTerm.length;
    const lastIndex = startIndex + len;
    str = str.replace(
      str.substring(startIndex, lastIndex),
      `</label><strong class="showWhiteSpace">${str.substring(
        startIndex,
        lastIndex,
      )}</strong><label class="showWhiteSpace" style=font-weight:500!important>`,
    );
    return str;
  }
  if (title) {
    return `<span class="showWhiteSpace" style=color:${colorCode}>${title}</span>`;
  }
};
const getLabel = (searchTerm, title, color) => {
  const colorCode = color || '#e10098';
  let str = title;
  title = title;
  searchTerm = searchTerm;
  if (title.indexOf(searchTerm) !== -1) {
    const startIndex = title.indexOf(searchTerm);
    const len = searchTerm.length;
    const lastIndex = startIndex + len;
    str = str.replace(
      str.substring(startIndex, lastIndex),
      `</label><strong class="showWhiteSpace">${str.substring(
        startIndex,
        lastIndex,
      )}</strong><label class="showWhiteSpace">`,
    );
    return `<strong class="showWhiteSpace" style={{white-space: pre-wrap;}}>${searchTerm}</strong><label class="showWhiteSpace" style=font-weight:500!important> en </label><span class="showWhiteSpace" style=color:${colorCode}>${title}</span>`;
  }
  return `<strong class="showWhiteSpace">${searchTerm}</strong><label class="showWhiteSpace" style=font-weight:500!important> en </label><span class="showWhiteSpace" style=color:${colorCode}>${title}</span>`;
};

const encodingParam = (param) => {
  try {
    const paramArray = Array.from(param);
    const symbolsArray = ['&', '%', '+'];
    let newParam = '';
    function encodeSymbol(i) {
      if (i === '&') {
        return '%26';
      } else if (i === '%') {
        return '%25';
      } else if (i === '+') {
        return '%2B';
      }
    }
    newParam = paramArray
      .map(word =>
        symbolsArray.includes(word)
          ? word.replace(word, encodeSymbol(word))
          : word,
      )
      .join('');
    if (typeof newParam === 'string' && newParam.length > 0) {
      return newParam;
    }
    return '';
  } catch (error) {
    console.log('Error utility encodingParam ', error);
    return '';
  }
};
// End Changes for GR Serach Facade
